import ITrainer from "types/Trainer";
import { createContext } from "react";

type RosterContext = {
  roster: ITrainer[];
  setRoster: (trainers: ITrainer[]) => any;
  published: boolean;
  updateDate: number;
};

const RosterContext = createContext<RosterContext>({
  roster: [],
  setRoster: null,
  published: false,
  updateDate: Date.now(),
});

export default RosterContext;
